<template>
  <div class="container-fluid footer-bg text-white p-4 px-5 text-center ">
    <div class="row d-flex justify-content-between">
      <div class="col-12 col-lg-6 text-lg-start">
        {{ t('footer.tagline') }}
      </div>
      <div class="col-12 col-lg-6 text-lg-end">
        {{ t('footer.copyright', { year: new Date().getFullYear() }) }}
      </div>
    </div>
  </div>
</template>

<script>
import { useCopy } from '@/composables/useCopy'

export default {
  setup() {
    return { ...useCopy() }
  }
}
</script>

<style scoped>
.footer-bg {
  background-color: #13647f;
  margin-bottom: 148px;
}



@media (min-width: 992px) { 

  .footer-bg {
    margin-bottom: 0px;
}
 
 }

</style>